export const HOME_PAGE_SECTION_DATA = "HOME_PAGE_SECTION_DATA";
export const SET_STORE_LIST = "SET_STORE_LIST";
export const SET_ANALYTICS_DATA = "SET_ANALYTICS_DATA";
export const SET_PAGE_TYPE = "SET_PAGE_TYPE";
